import controller from './dynamic-banner.controller';
import templateBase from './templates/dynamic-banner-base.view.html';

let DynamicBannerComponent = {
  template:changeTemplate,
  controller,
  bindings : {
    dbData : '<',
    dbName : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  return templateBase;

}

export default DynamicBannerComponent;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/shared/components/banners/dynamic-banner/dynamic-banner.component.js
 **/